import { Accordion, Card } from "react-bootstrap";
import AccordionHeader from "./AccordionHeader";


function Item2 ({setDefaultFocusItem, defaultFocusItem, focusKeywordId, itemListRefs, setItemListRefs, highlighted, setHighlighted, handleStatusClose,setStatusData,setStatusVariant,setShowStatusPopup,categoryId, tempCommentList, tempCommentListDispatch, handleActiveCommentChange, mobile,current, commentInput, commentInputDispatch, index, k, activeCommentKey, setActiveCommentKey, activeAccordion, setActiveAccordion, setActiveEl, activeEl, moduleItems, commentsList, commentsListDispatch}) {
    var keys = Object.keys(current);
    var i = null;
    var d = null;
    
    if(keys.includes("item")){
        i = keys.splice(keys.indexOf('item'),1);  
    }
    if(k!='x' && keys.includes("x")){
        d = keys.splice(keys.indexOf('x'),1);
    }

    return (
        <Card 
            className={i!=null ? Array.isArray(current['item']) ? "level-" + current['item']['0'].itemLevel : "level-" + current['item'].itemLevel : null}
            key={i!=null ? Array.isArray(current['item']) ? "item-" + current['item']['0'].id : "item-" + current['item'].id : null}
        >
        {
            i != null || (k=='x')
            ?
                <>
                    {
                        d!=null
                        ? 
                            Array.isArray(current['x']["item"]) ==true
                            ? 
                                <>
                                    <AccordionHeader
                                    setDefaultFocusItem={setDefaultFocusItem}
                                        defaultFocusItem={defaultFocusItem}
                                        handleActiveCommentChange={handleActiveCommentChange}
                                        eventKey={current['item'].itemNum}
                                        activeAccordion={activeAccordion} 
                                        setActiveAccordion={setActiveAccordion}
                                        activeCommentKey={activeCommentKey}
                                        setActiveCommentKey={setActiveCommentKey}
                                        // activeCommentKeyValue={activeCommentKeyValue}
                                        // setActiveCommentKeyValue={setActiveCommentKeyValue}
                                        activeEl={activeEl} 
                                        setActiveEl={setActiveEl} 
                                        isEnd={false}
                                        isX={false}
                                        isArrItem={false}
                                        item={current['item']}
                                        moduleItems={moduleItems}
                                        commentsList={commentsList}
                                        commentsListDispatch={commentsListDispatch}
                                        key={"header" + current['item'].id}
                                        mobile={mobile}
                                        commentInput={commentInput}
                                        commentInputDispatch={commentInputDispatch}
                                        tempCommentList={tempCommentList}
                                        tempCommentListDispatch={tempCommentListDispatch}
                                        categoryId={categoryId}

                                        handleStatusClose={handleStatusClose}
                                        setStatusData={setStatusData}
                                        setStatusVariant={setStatusVariant}
                                        setShowStatusPopup={setShowStatusPopup}
                                        highlighted={highlighted}
                                                                    setHighlighted={setHighlighted}
                                                                    itemListRefs={itemListRefs}
                                                                    setItemListRefs={setItemListRefs}
                                                                    focusKeywordId={focusKeywordId}
                                    ></AccordionHeader>
                                    
                                    <Accordion.Collapse eventKey={current["item"].itemNum} key={current["item"].id}>
                                        <Accordion alwaysOpen activeKey={activeAccordion} bsPrefix="ct-accordion">
                                                        
                                            {
                                                current['x']["item"].map((val) => { 
                                                    return ( 
                                                        <Card>
                                                            <AccordionHeader
                                                            setDefaultFocusItem={setDefaultFocusItem}
                                                                defaultFocusItem={defaultFocusItem}
                                                                handleActiveCommentChange={handleActiveCommentChange}
                                                                eventKey={null}
                                                                activeAccordion={activeAccordion} 
                                                                setActiveAccordion={setActiveAccordion}
                                                                activeCommentKey={activeCommentKey}
                                                                setActiveCommentKey={setActiveCommentKey}
                                                                // activeCommentKeyValue={activeCommentKeyValue}
                                                                // setActiveCommentKeyValue={setActiveCommentKeyValue}
                                                                activeEl={activeEl} 
                                                                setActiveEl={setActiveEl} 
                                                                isEnd={true}
                                                                isX={true}
                                                                isArrItem={true}
                                                                item={val}
                                                                moduleItems={moduleItems}
                                                                commentsList={commentsList}
                                                                commentsListDispatch={commentsListDispatch}
                                                                key={"header" + val.id}
                                                                mobile={mobile}
                                                                commentInput={commentInput}
                                                                commentInputDispatch={commentInputDispatch}
                                                                tempCommentList={tempCommentList}
                                                                tempCommentListDispatch={tempCommentListDispatch}
                                                                categoryId={categoryId}

                                                                
                                                                handleStatusClose={handleStatusClose}
                                                                setStatusData={setStatusData}
                                                                setStatusVariant={setStatusVariant}
                                                                setShowStatusPopup={setShowStatusPopup}
                                                                highlighted={highlighted}
                                                                    setHighlighted={setHighlighted}
                                                                    itemListRefs={itemListRefs}
                                                                    setItemListRefs={setItemListRefs}
                                                                    focusKeywordId={focusKeywordId}
                                                            ></AccordionHeader>
                                                        </Card>
                                                    )
                                                })
                                            }
                                           
                                        </Accordion>
                                    </Accordion.Collapse>
                                </>
                            :   
                                
                                <>
                                    <AccordionHeader
                                    setDefaultFocusItem={setDefaultFocusItem}
                                        defaultFocusItem={defaultFocusItem}
                                        handleActiveCommentChange={handleActiveCommentChange}
                                        eventKey={current['item'].itemNum}
                                        activeAccordion={activeAccordion} 
                                        setActiveAccordion={setActiveAccordion}
                                        activeCommentKey={activeCommentKey}
                                        setActiveCommentKey={setActiveCommentKey}
                                        // activeCommentKeyValue={activeCommentKeyValue}
                                        // setActiveCommentKeyValue={setActiveCommentKeyValue}
                                        activeEl={activeEl} 
                                        setActiveEl={setActiveEl} 
                                        isEnd={false}
                                        isX={false}
                                        isArrItem={false}
                                        item={current['item']}
                                        moduleItems={moduleItems}
                                        commentsList={commentsList}
                                        commentsListDispatch={commentsListDispatch}
                                        key={"header" + current['item'].id}
                                        mobile={mobile}
                                        commentInput={commentInput}
                                        commentInputDispatch={commentInputDispatch}
                                        tempCommentList={tempCommentList}
                                        tempCommentListDispatch={tempCommentListDispatch}
                                        categoryId={categoryId}

                                        handleStatusClose={handleStatusClose}
                                                                setStatusData={setStatusData}
                                                                setStatusVariant={setStatusVariant}
                                                                setShowStatusPopup={setShowStatusPopup}
                                                                highlighted={highlighted}
                                                                    setHighlighted={setHighlighted}
                                                                    itemListRefs={itemListRefs}
                                                                    setItemListRefs={setItemListRefs}
                                                                    focusKeywordId={focusKeywordId}
                                    ></AccordionHeader>
                                    <Accordion.Collapse eventKey={current['item'].itemNum} key={"collapse"+current["item"].id}>
                                        <Accordion alwaysOpen activeKey={activeAccordion} bsPrefix="ct-accordion">
                                            <Card>
                                                <AccordionHeader
                                                setDefaultFocusItem={setDefaultFocusItem}
                                                    defaultFocusItem={defaultFocusItem}
                                                    handleActiveCommentChange={handleActiveCommentChange}
                                                    eventKey={current['x']["item"].itemNum} 
                                                    activeAccordion={activeAccordion} 
                                                    setActiveAccordion={setActiveAccordion}
                                                    activeCommentKey={activeCommentKey}
                                                    setActiveCommentKey={setActiveCommentKey}
                                                    // activeCommentKeyValue={activeCommentKeyValue}
                                                    // setActiveCommentKeyValue={setActiveCommentKeyValue}
                                                    activeEl={activeEl} 
                                                    setActiveEl={setActiveEl} 
                                                    isEnd={true}
                                                    isX={true}
                                                    isArrItem={false}
                                                    item={current["x"]['item']}
                                                    moduleItems={moduleItems}
                                                    commentsList={commentsList}
                                                    commentsListDispatch={commentsListDispatch}
                                                    mobile={mobile}
                                                   commentInput={commentInput}
                                                    commentInputDispatch={commentInputDispatch}
                                                    tempCommentList={tempCommentList}
                                                    tempCommentListDispatch={tempCommentListDispatch}
                                                    categoryId={categoryId}
                                                    handleStatusClose={handleStatusClose}
                                                                setStatusData={setStatusData}
                                                                setStatusVariant={setStatusVariant}
                                                                setShowStatusPopup={setShowStatusPopup}
                                                                highlighted={highlighted}
                                                                    setHighlighted={setHighlighted}
                                                                    itemListRefs={itemListRefs}
                                                                    setItemListRefs={setItemListRefs}
                                                                    focusKeywordId={focusKeywordId}
                                                >
                                                </AccordionHeader>
                                            </Card>
                                        </Accordion>
                                    </Accordion.Collapse>
                                </>
                        :   
                            <AccordionHeader
                            setDefaultFocusItem={setDefaultFocusItem}
                                defaultFocusItem={defaultFocusItem}
                                handleActiveCommentChange={handleActiveCommentChange}
                                eventKey={current["item"].itemNum} 
                                activeAccordion={activeAccordion} 
                                setActiveAccordion={setActiveAccordion}
                                activeCommentKey={activeCommentKey}
                                setActiveCommentKey={setActiveCommentKey}
                                // activeCommentKeyValue={activeCommentKeyValue}
                                // setActiveCommentKeyValue={setActiveCommentKeyValue}
                                activeEl={activeEl} 
                                setActiveEl={setActiveEl} 
                                isEnd={!(keys.length > 0)}
                                isX={false}
                                isArrItem={false}
                                item={current["item"]}
                                moduleItems={moduleItems}
                                commentsList={commentsList}
                                commentsListDispatch={commentsListDispatch}
                                mobile={mobile}
                                commentInput={commentInput}
                                commentInputDispatch={commentInputDispatch}
                                tempCommentList={tempCommentList}
                                tempCommentListDispatch={tempCommentListDispatch}
                                categoryId={categoryId}
                                handleStatusClose={handleStatusClose}
                                setStatusData={setStatusData}
                                setStatusVariant={setStatusVariant}
                                setShowStatusPopup={setShowStatusPopup}
                                highlighted={highlighted}
                                setHighlighted={setHighlighted}
                                itemListRefs={itemListRefs}
                                                                    setItemListRefs={setItemListRefs}
                                                                    focusKeywordId={focusKeywordId}
                            >    
                            </AccordionHeader>
                    }
                </>
            : null
        } 
        {   keys.length > 0  
            ?
                <Accordion.Collapse eventKey={current["item"].itemNum} key={"collapse" + current["item"].id}>
                    <Accordion alwaysOpen activeKey={activeAccordion} bsPrefix="ct-accordion">
                        {   
                            keys.map((keyName, i)=>{
                                return (
                                    <Item2 
                                    setDefaultFocusItem={setDefaultFocusItem}
                                    defaultFocusItem={defaultFocusItem}
                                    handleActiveCommentChange={handleActiveCommentChange}
                                        current={current[keyName]} 
                                        index={index+1} 
                                        k={keyName} 
                                        activeAccordion={activeAccordion} 
                                        setActiveAccordion={setActiveAccordion} 
                                        activeCommentKey={activeCommentKey}
                                        setActiveCommentKey={setActiveCommentKey}
                                        // activeCommentKeyValue={activeCommentKeyValue}
                                        // setActiveCommentKeyValue={setActiveCommentKeyValue}
                                        activeEl={activeEl} 
                                        setActiveEl={setActiveEl} 
                                        moduleItems={moduleItems}
                                        commentsList={commentsList}
                                        commentsListDispatch={commentsListDispatch}
                                        key={"item2" + keyName}
                                        mobile={mobile}
                                        commentInput={commentInput}
                                        commentInputDispatch={commentInputDispatch}
                                        tempCommentList={tempCommentList}
                                        tempCommentListDispatch={tempCommentListDispatch}
                                        categoryId={categoryId}
                                        handleStatusClose={handleStatusClose}
                                        setStatusData={setStatusData}
                                        setStatusVariant={setStatusVariant}
                                        setShowStatusPopup={setShowStatusPopup}
                                        highlighted={highlighted}
                                        setHighlighted={setHighlighted}
                                        itemListRefs={itemListRefs}
                                        setItemListRefs={setItemListRefs}
                                        focusKeywordId={focusKeywordId}
                                    ></Item2>
                                )
                            }) 
                        }
                    </Accordion>
                </Accordion.Collapse>
            :   null 
        }
        </Card>
    )
}

export default Item2;
